import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {SharedModule} from '../../shared.module';
import {
    AggregationLevel,
    LocationData,
    VULCAN_DEFAULT_AGGREGATION_LEVELS,
    VulcanLocationFilterComponent,
} from '@eagle-i/vulcan-component-library';

export interface LocationFilterModalDataOptions {
    autoSelectCodes?: string[];
    autoSelectAggregationLevel?: AggregationLevel;
    showAggregationLevels: boolean;
    aggregationLevels?: AggregationLevel[];
    showCounties?: boolean;
}

@Component({
    selector: 'eaglei-location-filter-modal',
    standalone: true,
    imports: [MatDialogContent, MatButton, MatDialogClose, MatDialogActions, SharedModule, VulcanLocationFilterComponent],
    templateUrl: './location-filter-modal.component.html',
    styleUrl: './location-filter-modal.component.scss',
})
export class LocationFilterModalComponent {
    public newFeatures: LocationData | null;
    public data: LocationFilterModalDataOptions = inject(MAT_DIALOG_DATA);

    public dialogRef = inject(MatDialogRef<LocationFilterModalComponent>);

    public get aggregationLevels(): AggregationLevel[] {
        return this.data.aggregationLevels || VULCAN_DEFAULT_AGGREGATION_LEVELS;
    }
    public get invalid(): boolean {
        return !this.newFeatures || !this.newFeatures.codes || (this.data.showAggregationLevels && !this.newFeatures.aggregationLevel);
    }
}
